
export enum StsNotificationType {
  Error = 1,
  Success = 2,
  Warning = 3,
  Info = 0 ,
  PasswordPolicyError = 4
}

// without this dummy class you can't export this enum (Typescript bug)
export default class StsEnums {

}

